import { Component, Input } from '@angular/core';
import { CommonModule } from '@angular/common';

@Component({
  selector: 'app-collapsible-card-mask',
  standalone: true,
  imports: [CommonModule],
  templateUrl: './collapsible-mask-card.html',
  styleUrls: ['./collapsible-mask-card.scss']
})
export class CollapsibleMaskCard {
  @Input() hasMask: boolean = false;
  @Input() isCollapsed: boolean = false; // ← ADICIONE ESTA LINHA
}
